import { ActionType } from '@superbet-group/web.types';
import { HowToOpen } from '../types/common';

export function extractActionType(link: string, howToOpen?: HowToOpen): ActionType {
    if (howToOpen) {
        return howToOpen === 'inApp' ? ActionType.openInAppLink : ActionType.openNewTab;
    }

    if (link.startsWith('/')) {
        return ActionType.openInAppLink;
    }
    return ActionType.openNewTab;
}
